import * as React from 'react';
import * as PropTypes from 'prop-types';
import Radio from './radio';
import Wave from '../_util/wave';
export default class RadioButton extends React.Component {
    render() {
        const radioProps = Object.assign({}, this.props);
        if (this.context.radioGroup) {
            radioProps.onChange = this.context.radioGroup.onChange;
            radioProps.checked = this.props.value === this.context.radioGroup.value;
            radioProps.disabled = this.props.disabled || this.context.radioGroup.disabled;
        }
        return (<Wave>
        <Radio {...radioProps}/>
      </Wave>);
    }
}
RadioButton.defaultProps = {
    prefixCls: 'ant-radio-button',
};
RadioButton.contextTypes = {
    radioGroup: PropTypes.any,
};



// WEBPACK FOOTER //
// ./components/radio/radioButton.tsx